"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashPassword = hashPassword;
exports.isPasswordMatch = isPasswordMatch;
const tslib_1 = require("tslib");
const bcryptjs_1 = tslib_1.__importDefault(require("bcryptjs"));
/**
 * Hashes a password using bcrypt.
 * @param password - The plain text password to hash.
 * @returns A promise that resolves to the hashed password.
 */
async function hashPassword(password) {
    const saltRounds = 10;
    return await bcryptjs_1.default.hash(password, saltRounds);
}
/**
 * Compares a plain text password with a hashed password.
 * @param plainPassword - The plain text password.
 * @param hashedPassword - The hashed password.
 * @returns A promise that resolves to a boolean indicating if the passwords match.
 */
async function isPasswordMatch(plainPassword, hashedPassword) {
    return await bcryptjs_1.default.compare(plainPassword, hashedPassword);
}
